<ng-template #formFields let-fields>
  @for (item of fields; track item) {
    <div class="edit-form-field">
      @if (item.type === 'text') {
        <mat-form-field hideRequiredMarker>
          <mat-label>
            {{ item.label }}
            @if (item.required) {
              <em i18n="@@core.common.required">(required)</em>
            }
          </mat-label>
          <input matInput [formControl]="getControl(item.name)" [placeholder]="item.placeholder || item.label">
        </mat-form-field>
      }
      @if (item.type === 'number' || item.type === 'integer') {
        <mat-form-field hideRequiredMarker>
          <mat-label>
            {{ item.label }}
            @if (item.required) {
              <em i18n="@@core.common.required">(required)</em>
            }
          </mat-label>
          <input matInput [formControl]="getControl(item.name)" [placeholder]="item.placeholder || item.label" type="number">
        </mat-form-field>
      }
      @if (item.type === 'date') {
        <mat-form-field hideRequiredMarker>
          <mat-label>
            {{ item.label }}
            @if (item.required) {
              <em i18n="@@core.common.required">(required)</em>
            }
          </mat-label>
          <input matInput [matDatepicker]="dp" [formControl]="getControl(item.name)" [placeholder]="item.placeholder || item.label" />
          <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
          <mat-datepicker #dp></mat-datepicker>
        </mat-form-field>
      }
      @if (item.type === 'timestamp') {
        <mat-form-field hideRequiredMarker>
          <mat-label>
            {{ item.label }}
            @if (item.required) {
              <em i18n="@@core.common.required">(required)</em>
            }
          </mat-label>
          <input matInput type="text" [formControl]="getControl(item.name)" [placeholder]="item.placeholder || item.label">
        </mat-form-field>
      }
      @if (item.type === 'textarea') {
        <mat-form-field hideRequiredMarker>
          <mat-label>
            {{ item.label }}
            @if (item.required) {
              <em i18n="@@core.common.required">(required)</em>
            }
          </mat-label>
          <textarea matInput [formControl]="getControl(item.name)" [placeholder]="item.placeholder || item.label"></textarea>
        </mat-form-field>
      }
      @if (item.type === 'select') {
        <tm-select-field
          [formControl]="getControl(item.name)"
          [item]="item"
          [layerId]="layerId"
          (clearUniqueValueCacheAfterSave)="clearUniqueValueCacheAfterSave.emit($event)"></tm-select-field>
      }
      @if (item.type === 'boolean') {
        <mat-checkbox [formControl]="getControl(item.name)">
          <mat-label>{{ item.label }}</mat-label>
        </mat-checkbox>
      }
    </div>
  }
</ng-template>

<form [formGroup]="form" class="edit-form">
  @if (tabs.length > 1) {
    <mat-tab-group>
      @for (tab of tabs; track tab.id) {
        <mat-tab [label]="tab.name">
          <ng-container *ngTemplateOutlet="formFields; context: { $implicit: formConfig.filter(f => f.tab === tab.id) }"></ng-container>
        </mat-tab>
      }
    </mat-tab-group>
  } @else {
    <ng-container *ngTemplateOutlet="formFields; context: { $implicit: formConfig }"></ng-container>
  }
</form>
